import { render, staticRenderFns } from "./DdsSupportedRegionsInfo.vue?vue&type=template&id=35976fa8&scoped=true"
import script from "./DdsSupportedRegionsInfo.vue?vue&type=script&lang=js"
export * from "./DdsSupportedRegionsInfo.vue?vue&type=script&lang=js"
import style0 from "./DdsSupportedRegionsInfo.vue?vue&type=style&index=0&id=35976fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35976fa8",
  null
  
)

export default component.exports